import { IDS } from "../constants/testIds";

const fmtTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const now = Date.now();
  const diff = Math.round((now - d.getTime()) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.round(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.round(diff / 3600)}h ago`;
  return `${Math.round(diff / 86400)}d ago`;
};

const magBar = (m) => {
  if (m == null) return "0%";
  return `${Math.min(100, Math.max(4, (m / 7) * 100))}%`;
};

const magClass = (m) => {
  if (m == null) return "text-[hsl(var(--ink-mid))]";
  if (m >= 6) return "text-[hsl(var(--seismic))] font-semibold";
  if (m >= 4.5) return "text-[hsl(14_60%_38%)]";
  return "text-[hsl(var(--ink))]";
};

const depthDot = (d) => {
  if (d == null) return "hsl(30 28% 32%)";
  if (d <= 15) return "hsl(14 66% 32%)";
  if (d <= 40) return "hsl(22 60% 40%)";
  if (d <= 100) return "hsl(30 28% 32%)";
  if (d <= 300) return "hsl(210 14% 42%)";
  return "hsl(218 22% 55%)";
};

export default function QuakeList({ quakes = [], loading }) {
  return (
    <div className="border border-[hsl(var(--ink))]/40 bg-[hsl(var(--paper-2))]/60" data-testid={IDS.quakeList}>
      <div className="flex items-center justify-between px-3 py-2 border-b border-[hsl(var(--ink))]/25">
        <span className="mono text-[10px] uppercase tracking-[0.2em] text-[hsl(var(--ink-2))]">
          Recent tremors · GeoNet NZ
        </span>
        <span className="mono text-[10px] text-[hsl(var(--ink-mid))]">
          {loading ? "..." : `${quakes.length}`}
        </span>
      </div>
      <ul className="max-h-[280px] overflow-y-auto divide-y divide-[hsl(var(--ink))]/15">
        {quakes.length === 0 && (
          <li className="px-3 py-4 text-sm text-[hsl(var(--ink-mid))]">
            {loading ? "Listening…" : "No felt tremors reported."}
          </li>
        )}
        {quakes.slice(0, 30).map((q) => (
          <li
            key={q.publicID}
            data-testid={IDS.quakeItem}
            className="px-3 py-2 flex items-center gap-3 hover:bg-[hsl(var(--paper))]/60 transition-colors fade-in-up"
          >
            <span
              className="w-2.5 h-2.5 rounded-full shrink-0 border border-[hsl(24_22%_8%)]"
              style={{ backgroundColor: depthDot(q.depth) }}
              title={q.depth != null ? `${Math.round(q.depth)} km deep` : "unknown depth"}
              aria-hidden
            />
            <div className="min-w-[46px] text-right">
              <div className={`font-display text-lg leading-none ${magClass(q.magnitude)}`}>
                {q.magnitude != null ? q.magnitude.toFixed(1) : "—"}
              </div>
              <div className="mono text-[9px] uppercase tracking-widest text-[hsl(var(--ink-mid))]">M</div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm text-[hsl(var(--ink))] truncate">{q.locality || "Unknown locality"}</div>
              <div className="mono text-[10px] text-[hsl(var(--ink-mid))] flex gap-2">
                <span>{fmtTime(q.time)}</span>
                <span>·</span>
                <span>{q.depth != null ? `${Math.round(q.depth)}km` : ""}</span>
                {q.mmi != null && (
                  <>
                    <span>·</span>
                    <span>MMI {q.mmi}</span>
                  </>
                )}
              </div>
            </div>
            <div className="w-[70px] h-[3px] bg-[hsl(var(--ink))]/15">
              <div
                className="h-full bg-[hsl(var(--seismic))]"
                style={{ width: magBar(q.magnitude) }}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
